let played = false;

export const takeIntroDelay = () => {
  const d = played ? 0.15 : 2.3;
  played = true;
  return d;
};

export const slugify = (s) =>
  s.toLowerCase().replace(/[’']/g, "").replace(/[^a-z0-9]+/g, "-").replace(/(^-|-$)/g, "");
